var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 75,
    viewBox: "0 0 85 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28240_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.02751 21.6042L3.77246 13.9948L11.3819 13.7397L11.637 21.3492L4.02751 21.6042ZM4.45303 14.6317L4.66413 20.9233L10.9557 20.7122L10.7446 14.4206L4.45303 14.6317Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7384 5.14453C21.7384 6.46668 20.6664 7.53907 19.3439 7.53907C18.0218 7.53907 16.9497 6.46701 16.9497 5.14453C16.9497 3.82239 18.0218 2.75 19.3439 2.75C20.6664 2.75033 21.7384 3.82239 21.7384 5.14453Z",
    fill: "#DC6803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1999 5.01772L60.0674 5.52637L65.1222 6.84374L65.2547 6.33509L60.1999 5.01772Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0646 3.34166L61.7466 8.39624L62.2552 8.52885L63.5731 3.47427L63.0646 3.34166Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3188 28.3477C71.0102 28.1339 69.3058 26.0817 69.5196 23.773C69.7333 21.4641 71.7856 19.7597 74.0942 19.9734C76.4032 20.1872 78.1076 22.2394 77.8938 24.5484C77.6801 26.857 75.6278 28.5614 73.3188 28.3477ZM74.0367 20.5945C72.0707 20.4125 70.323 21.8641 70.141 23.8305C69.959 25.7969 71.4103 27.5445 73.3767 27.7266C75.343 27.9086 77.0907 26.457 77.2727 24.4906C77.4544 22.5242 76.0031 20.7766 74.0367 20.5945Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8592 3.73511L1.08226 60.9842C-1.77017 65.5483 1.34953 71.6156 6.54429 71.609C58.003 71.5436 38.8295 71.6113 78.0952 71.6232C83.287 71.6248 86.4011 65.5602 83.5506 60.9984L47.7644 3.73511C45.1875 -0.388591 39.4361 -0.388591 36.8592 3.73511Z",
    fill: "#F46E00",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.752 57.2429C38.752 55.0578 40.2694 53.4796 42.3332 53.4796C44.5183 53.4796 45.9144 55.0578 45.9144 57.2429C45.9144 59.3672 44.5183 61.0062 42.3332 61.0062C40.2086 61.0062 38.752 59.3672 38.752 57.2429ZM40.2462 47.7751L39.4438 20.2634C39.4305 19.8062 39.7976 19.4282 40.2551 19.4282H44.4109C44.8685 19.4282 45.2355 19.8062 45.2223 20.2634L44.4198 47.7751C44.4069 48.2138 44.0475 48.563 43.6084 48.563H41.0576C40.6186 48.563 40.2591 48.2142 40.2462 47.7751Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0509 3.81952L1.13669 63.8345C-1.32789 68.6189 2.28341 74.4074 7.45967 73.9706C58.7363 69.6451 39.6342 71.2999 78.7661 68.0606C83.94 67.6324 86.5417 61.3306 83.3229 57.0206L42.9188 2.91661C40.0092 -0.979463 34.2776 -0.503067 32.0509 3.81952Z",
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3671 56.9871C38.1861 54.8096 39.5677 53.1112 41.6243 52.9404C43.8018 52.7594 45.3238 54.2166 45.5048 56.3941C45.6806 58.5111 44.4252 60.2601 42.2477 60.4408C40.1307 60.6169 38.5432 59.1045 38.3671 56.9871ZM39.0728 47.4285L35.9954 20.0777C35.9442 19.6231 36.2789 19.2161 36.7348 19.1781L40.8763 18.8342C41.3322 18.7962 41.7293 19.1424 41.7538 19.5993L43.2319 47.0829C43.2553 47.5213 42.9263 47.8989 42.4885 47.9353L39.9463 48.1464C39.5089 48.1827 39.1217 47.8646 39.0728 47.4285Z",
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28240_1771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 74.258,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.78a12a493293c99ab7d82610d1534be7.svg";
export { ForwardRef as ReactComponent };